var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:{ 'two-sections': _vm.showProjects && _vm.selectedStudent }},[_c('students-list'),(_vm.selectedStudent)?_c('student-viewer'):_vm._e(),(_vm.showProjects)?_c('projects-list'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }